import * as XLSX from "xlsx";

export function ExportToExcel(
  chartData,
  fileName = "data.xlsx",
  restore = true
) {
  // Prepare data for worksheet
  // We assume chartData has categories and series arrays
  const { categories, series } = chartData;

  // Create array of rows, headers first:
  const headers = ["Category", ...series.map((s) => s.name)];
  const rows = categories.map((cat, i) => {
    const row = [cat];
    console.log(row);
    if (restore) {
      series.forEach((s) => {
        row.push(s.data[i] * 1000000000000);
      });
    } else {
      series.forEach((s) => {
        row.push(s.data[i]);
      });
    }
    return row;
  });
  const worksheetData = [headers, ...rows];

  // Create worksheet and workbook
  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  // Write workbook and trigger download
  XLSX.writeFile(workbook, fileName);
  console.log("wsheetdata", chartData, worksheetData);
}
